export default __webpack_public_path__ + "static/media/image_of_me.c83af58d.jpg";